// extracted by mini-css-extract-plugin
export default {"promptContainer":"Prompt_promptContainer__MzSX5","fadeIn":"Prompt_fadeIn__lJ055","promptInput":"Prompt_promptInput__yvxEz"};